import http from '../index'

export const loginApi = params => {
  return http.post(`/app/app/login`, params)
}
